import { defineNuxtPlugin } from '#imports'

        export default defineNuxtPlugin(async (nuxtApp) => {
          if (import.meta.client) {
            const vueform = (await import('@vueform/vueform')).vueform
            const vueformConfig = (await import('/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/vueform.config.js')).default
            
            nuxtApp.vueApp.use(vueform, vueformConfig)
          }
        })
        